var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "1000",
      "title": _vm.openedSales.customer ? _vm.openedSales.customer.name : ''
    },
    on: {
      "on-close": _vm.closeDrawer
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Modal', {
    on: {
      "on-ok": _vm.delPriceMethod,
      "on-cancel": _vm.cancelDel
    },
    model: {
      value: _vm.delPriceModel,
      callback: function ($$v) {
        _vm.delPriceModel = $$v;
      },
      expression: "delPriceModel"
    }
  }, [_c('p', [_vm._v("您确认要删除此条价格记录吗？")])]), _c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "currentCost"
  }, [_c('div', {
    staticClass: "sale-price cost"
  }, [_c('div', [_vm._v("售价（元）")]), _c('div', {
    staticClass: "price"
  }, [_vm._v(" " + _vm._s(_vm.price ? _vm.price : _vm.openedSales.price ? _vm.openedSales.price.price : 0) + " ")])]), _c('div', {
    staticClass: "freight cost"
  }, [_c('div', [_vm._v("运费（元）")]), _c('div', {
    staticClass: "price"
  }, [_vm._v(" " + _vm._s(_vm.transCost ? _vm.transCost : _vm.openedSales.transCost ? _vm.openedSales.transCost.cost : 0) + " ")])]), _c('div', {
    staticClass: "operation-cost cost"
  }, [_c('div', [_vm._v("业务费（元）")]), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.promoFeeSum))])]), _c('div', {
    staticClass: "estAging-cost cost"
  }, [_c('div', [_vm._v("账龄（月）")]), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.estAging))])]), _c('div', {
    staticClass: "transDist-cost cost"
  }, [_c('div', [_vm._v("运距（KM）")]), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.transDist))])])]), _c('div', {
    staticClass: "dashed"
  }), _c('div', {
    staticClass: "cost-records"
  }, [_c('div', {
    staticClass: "sale-table table"
  }, [_c('div', [_vm._v("售价")]), _c('div', {
    staticClass: "top"
  }, [_c('InputNumber', {
    attrs: {
      "controls-outside": ""
    },
    model: {
      value: _vm.salePrice,
      callback: function ($$v) {
        _vm.salePrice = $$v;
      },
      expression: "salePrice"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addPrice('sales');
      }
    }
  }, [_vm._v("添加")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "data": _vm.salesPriceRecordList,
      "columns": _vm.salesPriceColumns
    },
    scopedSlots: _vm._u([{
      key: "deleteBtn",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline",
            "size": "23"
          },
          on: {
            "click": function ($event) {
              return _vm.delPrice(row._id, 'salesPrice');
            }
          }
        })];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "freight-table table"
  }, [_c('div', [_vm._v("运费")]), _c('div', {
    staticClass: "top"
  }, [_c('InputNumber', {
    attrs: {
      "controls-outside": ""
    },
    model: {
      value: _vm.transPrice,
      callback: function ($$v) {
        _vm.transPrice = $$v;
      },
      expression: "transPrice"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addPrice('trans');
      }
    }
  }, [_vm._v("添加")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "data": _vm.salesTransCostRecordList,
      "columns": _vm.salesTransPriceColumns
    },
    scopedSlots: _vm._u([{
      key: "deleteBtn",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline",
            "size": "23"
          },
          on: {
            "click": function ($event) {
              return _vm.delPrice(row._id, 'transPrice');
            }
          }
        })];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "operation-table table"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', [_vm._v("业务费")]), _c('Button', {
    attrs: {
      "disabled": _vm.currentUser.superAdmin ? false : _vm.arrayIntersection(['ywf'], _vm.currentUser.simpleRole).length > 0 ? false : true,
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.showSetPromoFeeModal();
      }
    }
  }, [_vm._v("设置")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "data": _vm.currentPromoFeeList,
      "columns": _vm.promoFeeColumns
    }
  })], 1), _c('Modal', {
    attrs: {
      "title": _vm.openedSales.customer ? _vm.openedSales.customer.name + '业务费' : '',
      "loading": _vm.setPromoFeeModalLoading,
      "width": "1300"
    },
    on: {
      "on-ok": _vm.setPromoFee,
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.isShowSetPromoFeeModal,
      callback: function ($$v) {
        _vm.isShowSetPromoFeeModal = $$v;
      },
      expression: "isShowSetPromoFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-wrap"
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', {
    staticClass: "modalTitle",
    staticStyle: {
      "margin-bottom": "21px"
    }
  }, [_c('div', [_vm._v("当前业务费")]), _c('div', [_vm._v(" 合计：" + _vm._s(_vm.savePromoFeeSum ? _vm.savePromoFeeSum : _vm.promoFeeSum) + "元 ")])]), _c('Table', {
    attrs: {
      "border": "",
      "data": _vm.saveCurrentPromoFeeList,
      "columns": _vm.currentPromoFeeColumns
    }
  })], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "modalTitle"
  }, [_c('div', [_vm._v("业务费列表")]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addPromoFee('fee');
      }
    }
  }, [_vm._v("添加")]), _c('Modal', {
    attrs: {
      "title": "添加业务费",
      "mask-closable": false,
      "width": "300px"
    },
    on: {
      "on-ok": _vm.addPromoFeeRecord,
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.addPromoFeeRecordModal,
      callback: function ($$v) {
        _vm.addPromoFeeRecordModal = $$v;
      },
      expression: "addPromoFeeRecordModal"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "auto"
    }
  }, [_c('div', [_vm._v("选择联系人")]), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "选择联系人...",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: _vm.selectCustomerContact,
      callback: function ($$v) {
        _vm.selectCustomerContact = $$v;
      },
      expression: "selectCustomerContact"
    }
  }, _vm._l(_vm.customerContactList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _c('div', [_vm._v("业务费")]), _c('InputNumber', {
    staticStyle: {
      "width": "250px"
    },
    model: {
      value: _vm.promoFee,
      callback: function ($$v) {
        _vm.promoFee = $$v;
      },
      expression: "promoFee"
    }
  })], 1)])], 1)]), _c('Table', {
    attrs: {
      "border": "",
      "data": _vm.salesPromoFeeRecordList,
      "columns": _vm.promoFeeRecordsColumns,
      "height": "340"
    },
    on: {
      "on-selection-change": _vm.choosePromoFee
    }
  })], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "modalTitle"
  }, [_c('div', [_vm._v("客户联系人")]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.addPromoFee('contact');
      }
    }
  }, [_vm._v("添加")]), _c('Modal', {
    attrs: {
      "title": "添加客户联系人",
      "width": "300px",
      "mask-closable": false
    },
    on: {
      "on-ok": _vm.addCustomerContact,
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.addCustomerContactModal,
      callback: function ($$v) {
        _vm.addCustomerContactModal = $$v;
      },
      expression: "addCustomerContactModal"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "auto"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "输入联系人姓名...",
      "clearable": ""
    },
    model: {
      value: _vm.customerContact,
      callback: function ($$v) {
        _vm.customerContact = $$v;
      },
      expression: "customerContact"
    }
  })], 1)])], 1)]), _c('Table', {
    attrs: {
      "border": "",
      "data": _vm.customerContactList,
      "columns": _vm.customerContactColumns,
      "height": "340"
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "estAging-wrap"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', [_vm._v("账龄")]), _c('div', {
    staticClass: "top"
  }, [_c('InputNumber', {
    attrs: {
      "controls-outside": ""
    },
    model: {
      value: _vm.estAging,
      callback: function ($$v) {
        _vm.estAging = $$v;
      },
      expression: "estAging"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.setEstAging('sales');
      }
    }
  }, [_vm._v("设置")])], 1)]), _c('div', [_c('div', [_vm._v("运距")]), _c('div', {
    staticClass: "top"
  }, [_c('InputNumber', {
    attrs: {
      "controls-outside": ""
    },
    model: {
      value: _vm.transDist,
      callback: function ($$v) {
        _vm.transDist = $$v;
      },
      expression: "transDist"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.setTransDist('sales');
      }
    }
  }, [_vm._v("设置")])], 1)]), _c('div', [_c('div', [_vm._v("备注")]), _c('div', {
    staticClass: "remark"
  }, [_c('Input', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.remark,
      callback: function ($$v) {
        _vm.remark = $$v;
      },
      expression: "remark"
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.setRemark('sales');
      }
    }
  }, [_vm._v("保存")])], 1)])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }